// CreateStepFeatures — wizard pane 4.
// Substrate: design/add.html lines 521-570 — `<section data-pane="4">`.
//
// Backend-truth:
//   * Feature catalog → GET /api/realty/features/ (FeatureSerializer = {id, name}).
//   * Per-property toggle via POST /properties/{id}/features/ {feature_id}
//     (applied after the property is created — see CreateRealtyScreenContent).
//
// Per SR-5 the design's hardcoded English chip values ("elevator", "ac", …)
// are NOT backend Feature ids; the grid renders from the real catalog and
// selection is keyed on feature.id. RIC-3.0 — Feature.icon (backend) drives
// the per-chip icon; rows without an icon set fall back to the generic tag.
// Mirrors features/editRealty EditSectionFeatures.

const GENERIC_FEATURE_ICON = "fa-solid fa-tag";

function CreateStepFeatures({
  active,
  catalog,
  catalogState,
  catalogError,
  selectedIds,
  onToggle,
}) {
  return (
    <section
      className={active ? "ap-pane is-active" : "ap-pane"}
      data-pane="4"
      aria-labelledby="ap-pane-4"
      hidden={!active}
    >
      <header className="ap-pane__head">
        <h2 id="ap-pane-4">
          <i className="fa-solid fa-tags" aria-hidden="true" />
          Особливості
        </h2>
        <p>
          Виберіть всі особливості, що відповідають об'єкту. Можна позначити
          скільки треба.
        </p>
      </header>

      {catalogState === "loading" ? (
        <p className="form-hint">Завантаження каталогу особливостей…</p>
      ) : catalogState === "error" ? (
        <p className="form-hint text-danger" role="alert">
          {catalogError || "Не вдалося завантажити особливості."}
        </p>
      ) : catalog.length === 0 ? (
        <p className="form-hint">Каталог особливостей порожній.</p>
      ) : (
        <div className="features-grid">
          {catalog.map((feature) => (
            <label key={feature.id} className="feature-chip-input">
              <input
                type="checkbox"
                name="features"
                value={feature.id}
                checked={selectedIds.has(feature.id)}
                onChange={() => onToggle(feature.id)}
              />
              <i
                className={feature.icon || GENERIC_FEATURE_ICON}
                aria-hidden="true"
              />
              {feature.name}
            </label>
          ))}
        </div>
      )}

      <p className="ap-helper">
        <i className="fa-solid fa-circle-info" aria-hidden="true" />
        Не вистачає особливості? Зверніться до адміністрації — каталог Features
        розширюється.
      </p>
    </section>
  );
}

export default CreateStepFeatures;
